import { SET_USER_COLLECTION, SET_ACTIVE_USER_ORG } from './types';

export const storeUserCollection = user => {
    return {
        type: SET_USER_COLLECTION,
        payload: user
    };
};

export const setActiveManagerOrg = data => {
    console.log(``);
    console.log(`Org Switch Origin: ${data.origin}`);
    console.log(`Newly Focused Org: ${data.org_name}`);
    console.log(``);
    return {
        type: SET_ACTIVE_USER_ORG,
        payload: data
    };
};
